import { IGroupMeta, IModelGroup, IDropdownModel } from './types'

export const groupModels = (
  models: IDropdownModel[],
  groupMeta: Record<string, IGroupMeta>
): IModelGroup[] => {
  const buckets = models.reduce((acc, model) => {
    const list = acc.get(model.groupKey)

    if (list) list.push(model)
    else acc.set(model.groupKey, [model])

    return acc
  }, new Map<string, IDropdownModel[]>())

  const groups: IModelGroup[] = Array.from(buckets, ([key, bucketModels]) => {
    const meta = groupMeta[key]
    const sortedModels = bucketModels.sort((a, b) => b.order - a.order)
    return {
      key,
      label:
        sortedModels.length > 1 && meta ? meta.label : sortedModels[0].name,
      models: sortedModels,
      order: meta?.order ?? Number.MAX_SAFE_INTEGER,
      Icon: meta?.Icon ?? null
    }
  })

  return groups.sort((a, b) => a.order - b.order)
}

export const getProviderInitials = (label: string): string => {
  const trimmed = label.trim()
  if (!trimmed) return '?'
  return trimmed.charAt(0).toUpperCase()
}
